export default "__VITE_ASSET__BakryZb0__"